import { BaseTooltipProcessor } from "./base";

import { array, isNil } from "@visactor/vutils";

export class GroupTooltipProcessor extends BaseTooltipProcessor {
    constructor() {
        super(...arguments), this.activeType = "group";
    }
    showTooltip(info, params, changePositionOnly) {
        const {datum: datum, series: series, dimensionInfo: dimensionInfo} = info, tooltipData = [ {
            datum: array(datum),
            series: series
        } ], newParams = Object.assign(Object.assign({}, params), {
            groupDatum: this._getGroupDatum(params),
            dimensionInfo: this._preprocessDimensionInfo(dimensionInfo),
            changePositionOnly: changePositionOnly,
            tooltip: this.component
        });
        return this._showTooltipByHandler(tooltipData, newParams);
    }
    shouldHandleTooltip(params, mouseEventData) {
        var _a;
        const {tooltipInfo: info} = mouseEventData;
        if (isNil(info)) return !1;
        const helper = null === (_a = params.model) || void 0 === _a ? void 0 : _a.tooltipHelper;
        return !!(null == helper ? void 0 : helper.activeType.includes("group"));
    }
    getMouseEventData(params, dimensionInfo) {
        var _a, _b;
        let info, ignore;
        if ("series" === (null === (_a = params.model) || void 0 === _a ? void 0 : _a.modelType)) {
            const series = params.model, helper = series.tooltipHelper, activeTriggers = null == helper ? void 0 : helper.activeTriggerSet.group, ignoreTriggers = null == helper ? void 0 : helper.ignoreTriggerSet.group;
            if ((null == activeTriggers ? void 0 : activeTriggers.has(params.model)) || (null == activeTriggers ? void 0 : activeTriggers.has(params.mark))) {
                const patternSpec = this.component.getSpec()[this.activeType];
                ((null == patternSpec ? void 0 : patternSpec.triggerMark) ? array(patternSpec.triggerMark) : []).includes(null === (_b = params.mark) || void 0 === _b ? void 0 : _b.name) && (info = {
                    mark: params.mark,
                    datum: params.datum,
                    series: series,
                    dimensionInfo: dimensionInfo
                });
            } else ((null == ignoreTriggers ? void 0 : ignoreTriggers.has(params.model)) || (null == ignoreTriggers ? void 0 : ignoreTriggers.has(params.mark))) && (ignore = !0);
        }
        return {
            tooltipInfo: info,
            ignore: ignore
        };
    }
    _getGroupDatum(params) {
        const {model: model, mark: mark, datum: datum} = params, series = model;
        if ([ "line", "area" ].includes(mark.type)) return array(datum);
        const datumList = series.getViewData().latestData, seriesField = series.getSeriesField();
        if (!seriesField) return datumList;
        const seriesFieldValue = array(datum)[0][seriesField];
        return datumList.filter((d => d[seriesField] === seriesFieldValue));
    }
}
//# sourceMappingURL=group-tooltip.js.map
